import { Link } from 'react-router-dom';

const ServiceItemCard = ({ title, short_description, image, slug }) => {
    return (
        <Link 
            to={slug} 
            className="group block bg-white rounded-2xl overflow-hidden shadow-sm ha:shadow-2xl transition-all duration-500 border border-gray-100"
        >
            {/* Image Container */}
            <div className="relative h-64 overflow-hidden">
                <img 
                    src={image} 
                    alt={title} 
                    className="w-full h-full object-cover transition-transform duration-700 gh:scale-110" 
                />
                {/* Dark Overlay on Hover */}
                <div className="absolute inset-0 bg-gradient-to-t from-brand-900/80 via-transparent to-transparent opacity-60 gh:opacity-90 transition-opacity duration-500" />
                
                {/* "View Detail" Button that appears on hover */}
                <div className="absolute bottom-4 left-4 right-4 translate-y-10 gh:translate-y-0 transition-transform duration-500">
                    <span className="block w-full py-2 bg-brand-500 text-white text-center text-xs font-bold uppercase tracking-tighter rounded-lg shadow-lg">
                        View Solution
                    </span>
                </div>
            </div>

            {/* Content Area */}
            <div className="p-6">
                <h5 className="Ethnocentric text-gray-900 text-lg mb-3 gh:text-brand-600 transition-colors">
                    {title}
                </h5>
                <p className="text-gray-500 text-sm leading-relaxed line-clamp-2">
                    {short_description}
                </p>
            </div>
        </Link>
    );
};

export default ServiceItemCard;